import React from 'react'
import {
  JobService,
  HomeService,
  ProjectService,
  AuthService,
} from '../../../services'
import { Link, withRouter } from 'react-router-dom'
import {
  Button,
  Modal,
  Select,
  Row,
  Col,
  Input,
  message,
  Form,
  Table,
  Popconfirm,
  PageHeader,
  Tag,
  Menu,
  Dropdown,
  DatePicker,
  Card,
  Space,
  Tooltip,
  Pagination,
  Image,
} from 'antd'
import { Config } from '../../../config'
import './style.scss'
import PaginationDetail from '../../PaginationDetail'

import JobEdit from '../job-edit'
import {
  Moment,
  strlimit,
  openNotificationWithIcon,
  ExportCSV,
} from '../../../helpers'
import JobView from '../job-view'
import JobAdd from '../job-form'
import _ from 'lodash'
import {
  ReadOutlined,
  EditOutlined,
  SearchOutlined,
  QuestionCircleFilled,
  DeleteFilled,
  BankFilled,
  UserOutlined,
  QuestionCircleOutlined,
  TrophyOutlined,
  PlusCircleOutlined,
  HomeOutlined,
  HomeFilled,
} from '@ant-design/icons'
import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import { JobStatus } from '../JobStatus'
import { JobDateTime } from '../JobDateTime'
import { JobDueDate } from '../JobDueDate'
import { InformfixStatus } from '../../informfix/InformfixStatus'
import { JobTechnichian } from '../JobTechnichian'

const { Column, ColumnGroup } = Table
const ButtonGroup = Button.Group

const IconText = ({ text, icon }) => (
  <span>
    {' '}
    {icon} {text}
  </span>
)

const { Option } = Select

const formatDateSearch = 'DD/MM/YYYY'

const STATUS_INFORMFIX_CANCEL = -1 // สถานะใบแจ้งซ่อม: ยกเลิก
const STATUS_INFORMFIX_WAIT = 1 //  สถานะใบแจ้งซ่อม: รอดำเนินการ
const STATUS_INFORMFIX_PROCEED = 2 // สถานะใบแจ้งซ่อม: กำลังดำเนินการ  สำหรับใช้แสดงหน้าจัดคิวงาน
const STATUS_INFORMFIX_COMPLETE = 3 //  สถานะใบแจ้งซ่อม: เสร็จแล้ว

@inject('informStore')
@observer
class JobProceed extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      initLoading: true,
      loading: false,
      loadingProject: false,
      data: [],
      showFormAdd: false,
      showFormEdit: false,
      showFormAssign: false,
      showModalView: false,
      jobId: '',
      searchParams: {
        project_id: '',
        job_status: '',
        q: '',
        f: 'subject',
        year: null,
        sortField: '',
        sortOrder: '',
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: Config.pager.limit,
        pageCount: 0,
      },
      job: {},
      visibleModalView: false,
      confirmLoading: false,
      projects: [{ id: 1, name: 'noom' }],
      listJobStatus: [],
    }

    this.formRef = React.createRef()
  }

  UNSAFE_componentWillMount() {
    // ดึงรายชื่อโครงการทั้งหมดมาตอนเปิดหน้าครั้งแรก
    this.getProjects()

    // โหลดข้อมูลสถานะ
    this.getJobStatus()
    // โหลดข้อมูลใบแจ้งซ่อม
  }
  componentDidMount() {
    this.handleSearch()

    const qry = queryString.parse(this.props.location.search)

    if (qry.project_id) {
      this.state.searchParams.project_id = qry.project_id
      this.formRef.current.setFieldsValue({
        project_id: qry.project_id,
      })
    }

    if (qry.job_status) {
      this.state.searchParams.job_status = qry.job_status
      this.formRef.current.setFieldsValue({
        job_status: qry.job_status,
      })
    }

    if (qry.f) {
      this.state.searchParams.f = qry.f
      this.formRef.current.setFieldsValue({
        f: qry.f,
      })
    }
    if (qry.year) {
      this.state.searchParams.year = qry.year
      this.formRef.current.setFieldsValue({
        f: qry.year,
      })
    }
    if (qry.f == 'date') {
      this.state.searchParams.q = qry.q
      if (qry.q) {
        this.formRef.current.setFieldsValue({
          q: Moment(qry.q).utc(7),
        })
      }
    } else {
      this.state.searchParams.q = qry.q
      this.formRef.current.setFieldsValue({
        q: qry.q,
      })
    }
  }

  setPageParams(params) {
    this.setState({
      pagination: {
        current: params.currentPage,
        total: params.totalCount,
        pageSize: params.perPage,
        pageCount: params.pageCount,
      },
    })
  }

  setQueryString() {
    let params = queryString.stringify(this.state.searchParams)
    this.props.history.push({
      search: params,
    })
  }

  handleSubmitSearch = (values) => {
    const pager = this.state.pagination
    const pageParams = { page: 1, 'per-page': pager.pageSize }
    let searchParams = this.state.search

    if (values.f == 'date') {
      let findDate = Moment(values.q)
        .utc(7)
        .format('YYYY-MM-DD')
      searchParams.q = findDate
      values.q = findDate
    }
    if (values.year) {
      let findY = Moment(values.year)
        .utc(7)
        .format('YYYY')
      searchParams.year = findY
      values.year = findY
    }
    console.log('year', values.year)

    this.setState({
      searchParams,
    })

    const params = { ...pageParams, ...values }
    JobService.listProceed(params)
      .then((rs) => {
        const data = rs.data['items']
        const pager = rs.data['_meta']
        this.setPageParams(pager)

        this.setState({
          data: data,
          loading: false,
          initLoading: false,
        })
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status
          if (code === 404) {
            message.warning(err.response.statusText)
          }
        }
        this.setState({
          data: [],
          loading: false,
          initLoading: false,
        })
      })
  }

  handleSearch = () => {
    this.setState({
      initLoading: true,
      loading: true,
    })

    const values = this.formRef.current.getFieldsValue()
    const pager = this.state.pagination
    const pageParams = { page: 1, 'per-page': pager.pageSize }
    let searchParams = this.state.searchParams

    if (values.f == 'date' && values.q != 'undefined') {
      let findDate = Moment(values.q)
        .utc(7)
        .format('YYYY-MM-DD')
      if (Moment(values.q).isValid()) {
        searchParams.q = findDate
        values.q = findDate
      } else {
        values.q = null
      }
    }

    if (values.year) {
      let findY = Moment(values.year)
        .utc(7)
        .format('YYYY')
      searchParams.year = findY
      values.year = findY
    }
    console.log('year', values.year)

    this.setState({
      searchParams,
    })

    const params = { ...pageParams, ...values }
    JobService.listProceed(params)
      .then((rs) => {
        const data = rs.data['items']
        const pager = rs.data['_meta']
        this.setPageParams(pager)

        this.setState({
          data: data,
          loading: false,
          initLoading: false,
        })
        this.setQueryString()
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status
          if (code === 404) {
            message.warning(err.response.statusText)
          }
        }
        this.setState({
          data: [],
          loading: false,
          initLoading: false,
        })
      })
  }

  handleTableChange = (pager, filters, sorter) => {
    console.log('pagerddd', pager)
    this.setState({
      initLoading: true,
      loading: true,
    })
    this.state.pagination.current = pager.current
    this.state.pagination.pageSize = pager.pageSize
    const search = {
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    }
    const searchParams = { ...this.state }
    searchParams.sortField = sorter.sortField
    searchParams.sortOrder = sorter.sortOrder

    this.setState({
      ...searchParams,
    })
    this.getData(search)
      .then((rs) => {
        const data = rs.data['items']
        const pager = rs.data['_meta']
        this.setPageParams(pager)

        this.setState({
          data: data,
          loading: false,
          initLoading: false,
        })
        this.setQueryString()
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status
          if (code === 404) {
            message.warning(err.response.statusText)
          }
        }
        this.setState({
          data: [],
          loading: false,
          initLoading: false,
        })
      })
  }

  /**
   * แสดงข้อมูลตาม Filter ที่เลือกไว้
   */
  getData = (params) => {
    const paramsSearch = {
      page: this.state.pagination ? this.state.pagination.current : 1,
      'per-page': this.state.pagination
        ? this.state.pagination.pageSize
        : Config.pager.limit,
      project_id: this.state.searchParams.project_id,
      job_status: this.state.searchParams.job_status,
      f: this.state.searchParams.f,
      q: this.state.searchParams.q,
    }
    const allParams = { ...paramsSearch, ...params }
    return JobService.listProceed(allParams)
  }

  /**
   * รีโหลดข้อมูล โดยไม่ต้อง reset Filter
   */
  reloadData = () => {
    this.setState({
      initLoading: true,
      loading: true,
    })
    this.getData()
      .then((rs) => {
        const data = rs.data['items']
        const pager = rs.data['_meta']
        this.setPageParams(pager)

        this.setState({
          data: data,
          loading: false,
          initLoading: false,
        })
      })
      .catch((err) => {
        const pager = { ...this.state.pagination }
        pager.current = 1
        pager.total = 0

        if (err.response) {
          const code = err.response.status
          if (code === 404) {
            message.warning(err.response.statusText)
          }
        }
        this.setState({
          data: [],
          loading: false,
          initLoading: false,
          pagination: pager,
        })
      })
  }

  /**
   * ข้อมูลสถานะ
   */
  getJobStatus() {
    JobService.getJobStatus().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listJobStatus: data })
      }
    })
  }
  /**
   * ข้อมูลโครงการทั้งหมด
   */
  getProjects() {
    this.setState({
      loadingProject: true,
    })
    ProjectService.all().then((pj) => {
      if (pj) {
        const dataProject = pj.data['data']
        this.setState({ projects: dataProject })
        this.setState({
          loadingProject: false,
        })
        this.getData().then((rs) => {
          const data = rs.data['items']
          const pager = rs.data['_meta']
          this.setState({
            initLoading: false,
            data: data,
          })
          this.setPageParams(pager)
        })
      }
    })
  }

  onChangeProject = (value) => {
    let searchParams = this.state.searchParams
    searchParams.project_id = value
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangeWorkStatus = (value) => {
    let searchParams = this.state.searchParams
    searchParams.work_status = value
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangeSearchFeild = (value) => {
    this.formRef.current.setFieldsValue({
      q: null,
    })
    let searchParams = this.state.searchParams
    searchParams.f = value
    const nowDate = Moment()
      .utc(7)
      .format('YYYY-MM-DD')
    if (value == 'date') {
      searchParams.q = null
      this.formRef.current.setFieldsValue({
        q: null,
      })
    } else {
      searchParams.q = null
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }

  onChangeQ = (e) => {
    e.persist()
    let searchParams = this.state.searchParams
    if (searchParams.f == 'date') {
    } else {
      searchParams.q = e.target.value
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangDate = (value) => {
    let searchParams = this.state.searchParams
    const date = Moment(value)
      .utc(7)
      .format('YYYY-MM-DD')
    console.log('date', date)
    if (Moment(value).isValid()) {
      searchParams.q = date
    } else {
      searchParams.q = null
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }

  setJobStatus = (item, status) => {
    if (status.value != undefined) {
      const jobStatus = status.value
      JobService.setJobStatus(item.id, {
        job_status: jobStatus,
      }).then((rs) => {
        const items = []
        const job = rs.data['data']
        const { data } = this.state
        data.map((record, index) => {
          if (record.id == job.id) {
            data[index] = job
          }
          items.push(data[index])
        })
        this.setState({
          data: items,
        })
        openNotificationWithIcon('success', rs.data.message)
      })
    }
  }

  resetForm() {
    this.setState({
      data: [],
      searchParams: {
        project_id: '',
        job_status: '',
        q: '',
        f: 'subject',
        sortFeild: '',
        sortOrder: '',
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: this.state.pagination.perPage,
        pageCount: 0,
      },
    })
    this.formRef.current.resetFields()
    this.setQueryString()

    this.handleSearch()
  }

  cancelJob = (item) => {
    JobService.cancel(item.id).then((rs) => {
      if (rs) {
        const data = rs.data['data']
        const { list } = this.state
        const index = list.indexOf(item)
        list[index] = data
        this.setState({
          list,
        })
        message.success(rs.data['message'])
      }
    })
  }

  // showFormAdd = () => {
  //   this.setState({ showFormAdd: true })
  // }
  // hideModalAdd = () => {
  //   this.setState({ showFormAdd: false })
  // }
  setVisibleModalAdd = (value) => {
    this.setState({
      showFormAdd: value,
    })
  }
  setVisibleModalEdit = (value) => {
    this.setState({
      showFormEdit: value,
    })
  }
  showModalEdit = (item) => {
    this.setState({
      jobId: item.id,
      job: {},
    })
    JobService.view(item.id).then((rs) => {
      this.setState({
        job: rs.data.data,
        showFormEdit: true,
      })
      console.log('dataedit', rs.data.data)
      this.props.informStore.setJob(this.state.job)
    })
  }
  showModalView = (item) => {
    this.setState({
      jobId: item.id,
      showModalView: true,
      job: {},
    })
    JobService.view(item.id).then((rs) => {
      this.setState({
        job: rs.data['data'],
      })
      this.props.informStore.setJob(this.state.job)
    })
  }

  hideModalEdit = () => {
    const job = this.props.informStore.getJob
    this.setState({
      showFormEdit: false,
      jobId: '',
      job: {},
    })
    this.props.informStore.setEditId('')
    if (job) {
      const { data } = this.state
      const items = []
      if (data) {
        data.map((item, index) => {
          if (item.id == job.id) {
            data[index] = job
          }
          items.push(data[index])
        })
        this.setState({
          data: items,
        })
      }
    }
  }

  hideModalView = () => {
    console.log('hide modal')
    this.props.informStore.setJob({})
    this.setState({
      showModalView: false,
      jobId: '',
      job: {},
    })
  }

  /**
   * ลบงาน
   */
  deleteJob = (record) => {
    const items = this.state.data
    JobService.delete(record.id).then((rs) => {
      message.success(rs.data['message'])
      let newItem = items.filter((item, key) => {
        return item.id != record.id
      })
      this.setState({
        data: newItem,
      })
    })
  }

  /**
   * ปิดคิวงานให้เสร็จ
   */
  closeJob = (item) => {
    let data = [...this.state.data]
    const index = data.indexOf(item)
    JobService.close(item.id).then((rs) => {
      data[index] = rs.data.data['job']
      this.setState({
        data,
      })
    })
  }

  /**
   * เคลียร์งานเก่าที่ค้าง
   */
  clearJobAuto = () => {
    JobService.clearJobAuto().then((rs) => {
      console.log('rs', rs)
    })
  }

  render() {
    const {
      initLoading,
      loading,
      loadingProject,
      pagination,
      projects,
      listJobStatus,
      searchParams,
    } = this.state



    /**
     * แสดงรายละเอียดโครงการและบ้าน
     */
    const showHomeDetail = (record) => {
      return (
        <div
          style={{
            fontSize: '12px',
          }}
        >
          {record.project ? (
            <div>
              <IconText
                key={'icon-project' + record.id}
                icon={<BankFilled />}
                text={record.project.name}
              />
            </div>
          ) : null}
          {record.home ? (
            <div>
              <IconText
                key={'icon-home' + record.id}
                icon={<HomeOutlined />}
                text={
                  'บ้านเลขที่ ' +
                  (record.home.home_no != undefined
                    ? record.home.home_no
                    : '-')
                }
              />
              {'  '}
              <IconText
                key={'icon-planno' + record.id}
                icon={<HomeOutlined />}
                text={
                  ' แปลง ' +
                  (record.home.plan_no != undefined
                    ? record.home.plan_no
                    : '-')
                }
              />
            </div>
          ) : null}
        </div>
      )
    }


    const menuJobStatus = (record) => {
      return (
        <Menu>
          {this.state.listJobStatus.map((status) => {
            return (
              <Menu.Item
                key={'menuItem-' + record.id + '-' + status.value}
                onClick={() => this.setJobStatus(record, status)}
              >
                {status.text}
              </Menu.Item>
            )
          })}
        </Menu>
      )
    }

    /**
     * ตรวจสอบว่าสามารถปิดงานได้อยู่หรือไม่
     * @param {*} record
     */
    const canCloseJob = (record) => {
      const c1 =
        record.job_status.toString() == '1' ||
        record.job_status.toString() == '2'
      // const c2 =
      //   record.informFix.work_status.toString() == '1' ||
      //   record.informFix.work_status.toString() == '2'
      return c1
    }

    return (
      <React.Fragment>
        <Card title="Filter">
          <Form
            ref={this.formRef}
            onFinish={this.handleSubmitSearch}
            initialValues={{
              // job_status: eval(
              //   qry.job_status ? qry.job_status : searchParams.job_status,
              // ),
              job_status: null,
            }}
          >
            <Row justify="space-between" gutter={{ xs: 3, sm: 3, md: 3 }}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 3 }}
                lg={{ span: 3 }}
              >
                <Form.Item name="year" labelAlign="right">
                  <DatePicker.YearPicker
                    format="YYYY"
                    placeholder="ปี ค.ศ."
                    size="small"
                  />
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 5 }}
              >
                <Form.Item name="project_id">
                  <Select
                    loading={loadingProject}
                    key="dropdown-project"
                    showSearch
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="-เลือกโครงการ-"
                    optionFilterProp="label"
                    optionLabelProp="label"
                    onChange={this.onChangeProject}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    size="small"
                  >
                    {projects.map((p, index) => (
                      <Option
                        key={'project-' + p.id}
                        value={p.id}
                        label={p.name}
                      >
                        {p.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {/* <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5 }}
                lg={{ span: 3 }}
              >
                <Form.Item name="job_status">
                  <Select
                    placeholder="-เลือกสถานะ-"
                    style={{ width: '100%' }}
                    onChange={this.onChangeWorkStatus}
                    // defaultActiveFirstOption={false}
                    size="small"
                    allowClear
                  >
                    <Option value="">-ไม่ระบุ-</Option>
                    {listJobStatus
                      ? listJobStatus.map((status, key) => (
                          <Option
                            key={key}
                            value={status.value}
                            label={status.text}
                          >
                            {status.text}
                          </Option>
                        ))
                      : null}
                  </Select>
                </Form.Item>
              </Col> */}
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 4 }}
                lg={{ span: 4 }}
              >
                <Form.Item name="f">
                  <Select
                    placeholder="-ประเภทคำค้นหา-"
                    style={{ width: '100%' }}
                    onChange={this.onChangeSearchFeild}
                    size="small"
                    allowClear
                    // defaultValue={qry.f ? qry.f : this.state.searchParams.f}
                  >
                    <Option value="informfix_id">เลขที่ใบแจ้งซ่อม</Option>
                    <Option value="subject">หัวข้อ</Option>
                    <Option value="description">รายละเอียด</Option>
                    <Option value="date">วันที่</Option>
                    <Option value="home_no">บ้านเลขที่</Option>
                    <Option value="plan_no">แปลงบ้าน</Option>
                    <Option value="id">ID</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 3 }}
                lg={{ span: 3 }}
              >
                <Form.Item name="q">
                  {searchParams.f == 'date' ? (
                    <DatePicker format={formatDateSearch} />
                  ) : (
                    <Input
                      name="q"
                      placeholder="คำค้นหา.."
                      onChange={this.onChangeQ}
                      onPressEnter={this.handleSearch}
                      size="small"
                      allowClear
                    />
                  )}
                </Form.Item>
              </Col>

              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 6 }}
              >
                <Button
                  type="primary"
                  loading={loading || initLoading}
                  disabled={loading || initLoading}
                  icon={<SearchOutlined />}
                  shape="circle"
                  onClick={this.handleSearch}
                  title="ค้นหา"
                  size="small"
                />
                <Space /> <Space />
                <Button
                  type="ghost"
                  onClick={() => this.setVisibleModalAdd(true)}
                  icon={<PlusCircleOutlined />}
                  size="small"
                >
                  เพิ่มคิวงาน
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>

        <div style={{ marginTop: 15 }}>
          {listJobStatus
            ? listJobStatus.map((status, key) => (
                <Button
                  shape="round"
                  type="info"
                  key={key}
                  onClick={() => {
                    this.formRef.current.setFieldsValue({
                      job_status: status.value,
                    })
                    this.state.searchParams.job_status = status.value
                    this.forceUpdate()
                    this.setQueryString()
                    this.handleSearch()
                  }}
                >
                  {status.text}
                </Button>
              ))
            : null}
        </div>

        <div style={{ marginTop: 15 }}>
          <ButtonGroup>
            {listJobStatus
              ? listJobStatus.map((status, key) => (
                  <Button
                    shape="round"
                    type="info"
                    key={key}
                    onClick={() => {
                      this.formRef.current.setFieldsValue({
                        job_status: status.value,
                      })
                      this.state.searchParams.job_status = status.value
                      this.forceUpdate()
                      this.setQueryString()
                      this.handleSearch()
                    }}
                  >
                    {status.text}
                  </Button>
                ))
              : null}
          </ButtonGroup>
        </div>

        {/* ////////////// START Modal Edit /////////// */}
        {this.state.jobId && this.state.showFormEdit ? (
          <JobEdit
            jobId={this.state.jobId}
            job={this.state.job}
            projects={this.state.projects}
            hideModal={this.hideModalEdit}
            visible={this.state.showFormEdit}
            onUpdated={(data) => {}}
            onCancel={(data) => {
              this.setVisibleModalEdit(false)
            }}
          />
        ) : null}
        {/* ////////////// END Modal Edit /////////// */}

        {/* ////////////// START Modal view /////////// */}
        <Modal
          open={this.state.showModalView}
          onCancel={this.hideModalView}
          afterClose={() => {
            this.hideModalView()
          }}
          footer=""
          centered
          bodyStyle={{ padding: '5' }}
          closable
          width={720}
        >
          {this.state.jobId && this.state.showModalView ? (
            <JobView
              jobId={this.state.jobId}
              job={this.props.informStore.getJob}
              hideModal={this.hideModalView}
              projects={this.state.projects}
            />
          ) : null}
        </Modal>
        {/* ////////////// END Modal view /////////// */}

        {/* ////////////// MODAL ADD ///////////////////// */}
        <JobAdd
          footer=""
          informId={0}
          visible={this.state.showFormAdd}
          onCreated={(data) => {
            this.handleSearch()
            this.setVisibleModalAdd(false)
          }}
          onCancel={(data) => {
            this.setVisibleModalAdd(false)
          }}
        />

        {/* <p>
          <Button onClick={() => this.clearJobAuto()}>เคลียร์งานที่ค้าง</Button>
        </p> */}

        {/* //////////////// Button group status ///////////////////////// */}
        {/* <div style={{ marginTop: 15 }}>
          {listJobStatus
            ? listJobStatus.map((status, key) => (
                <Button
                  shape="round"
                  type="info"
                  key={key}
                  onClick={() => {
                    this.formRef.current.setFieldsValue({
                      job_status: status.value,
                    })
                    this.state.searchParams.job_status = status.value
                    this.forceUpdate()
                    this.setQueryString()
                    this.handleSearch()
                  }}
                >
                  {status.text}
                </Button>
              ))
            : null}
        </div> */}
        {/* ///////////////////////////////////////// */}
        <PaginationDetail data={pagination} />

        {/* ///////////////////////////////////////// */}

        <Table
          style={{
            backgroundColor: '#ffffff',
            padding: 0,
          }}
          size="small"
          bordered
          rowKey={(record) => record.id}
          dataSource={this.state.data}
          pagination={this.state.pagination}
          loading={this.state.loading}
          onChange={this.handleTableChange}
          // rowClassName={(record, index) => {
          //   if (record.job_status) {
          //     switch (record.job_status.toString()) {
          //       case '-2':
          //         return 'job-status-postpone'
          //         break
          //       case '-1':
          //         return 'job-status-canceled'
          //         break
          //       case '1':
          //         return 'job-status-pending'
          //         break
          //       case '2':
          //         return 'job-status-operate'
          //         break
          //       case '3':
          //         return 'job-status-complete'
          //         break
          //       default:
          //         return null
          //         break
          //     }
          //   }
          // }}
        >
          <Column title="ID" dataIndex="id" key="id" width="60" />
          {/* <Column
            title="หมวดงาน"
            dataIndex="group"
            key="group"
            width="80"
            render={(group, record) => {
              return (
                <React.Fragment>
                  <div align="left">{group ? group.name : null}</div>
                  <JobDueDate data={record} />
                </React.Fragment>
              )
            }}
          /> */}
          <ColumnGroup title="เวลา">
            <Column
              title="ตั้งแต่"
              dataIndex="start_time"
              key="start_time"
              align="center"
              width="50"
              render={(start_time, record) => {
                return (
                  <React.Fragment>
                    <JobDateTime datetime={start_time} />
                  </React.Fragment>
                )
              }}
            />
            <Column
              title="ถึง"
              dataIndex="end_time"
              key="end_time"
              align="center"
              width="50"
              render={(end_time) => {
                return <JobDateTime datetime={end_time} />
              }}
            />
          </ColumnGroup>
          <Column
            title="รายการ"
            dataIndex="list"
            key="list"
            render={(list, record) => {
              return (
                <React.Fragment>
                  {record.imageCover ? (
                    <div>
                      <Image
                        src={record.imageCover.thumbnail}
                        alt={record.list}
                        style={{
                          width: 80,
                          borderRadius: 0,
                          marginTop: 3,
                          marginBottom: 3,
                        }}
                      />
                    </div>
                  ) : (
                    <Image
                      src="error"
                      alt={record.list}
                      fallback="data:image/png;base64,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"
                      style={{
                        width: 80,
                        borderRadius: 0,
                        marginTop: 3,
                        marginBottom: 3,
                      }}
                    />
                  )}
                  <div>
                    <a
                      style={{ fontWeight: 'bolder' }}
                      onClick={() => this.showModalView(record)}
                    >
                      {list}
                    </a>
                  </div>
                  <div>
                    {record.description
                      ? strlimit(record.description, 60)
                      : null}
                  </div>
                  <div style={{ fontWeight: 'normal', fontSize: 'small' }}>
                    {record.responsible_name ? (
                      <div>
                        <IconText
                          key={'icon-responsible' + record.id}
                          icon={<UserOutlined />}
                          text={record.responsible_name}
                        />
                      </div>
                    ) : null}

                    {record.group ? (
                      <Tag color="processing">{record.group.name}</Tag>
                    ) : null}
                  </div>

                  <div
                    align="center"
                    style={{
                      marginTop: 7,
                    }}
                  >
                    <React.Fragment>
                      <Row>
                        <Col>
                          <JobStatus
                            name={record.jobStatusName}
                            statusId={record.job_status}
                          />
                        </Col>
                        {/* ถ้าคิวงานเท่ากับ รอดำเนินการ , กำลังดำเนินการ */}
                        {record.job_status.toString() == '1' &&
                        record.job_status.toString() == '2' ? (
                          <Col>
                            <Dropdown.Button
                              trigger={['click']}
                              size="small"
                              overlay={menuJobStatus(record)}
                              style={{
                                // backgroundColor:
                                //   Config.job.jobStatus[record.job_status]
                                //     .background,
                                // color:
                                //   Config.job.jobStatus[record.job_status]
                                //     .color,
                                // padding: 3,
                                display: 'block',
                                textAlign: 'center',
                              }}
                            >
                              เปลี่ยนสถานะ
                            </Dropdown.Button>
                          </Col>
                        ) : (
                          ''
                        )}
                      </Row>
                    </React.Fragment>
                  </div>
                </React.Fragment>
              )
            }}
          />
          <Column
            title="เลขที่ใบแจ้งซ่อม"
            dataIndex="inform_fix_id"
            key="inform_fix_id"
            render={(text, record) => (
              <React.Fragment>
                {text ? text : '-ไม่ระบุ-'}
                <div>
                  {/* <InformfixStatus
                    name={record.informFix.workStatusName}
                    statusId={record.informFix.work_status}
                  /> */}
                  {record.informFix
                    ? '(' + record.informFix.workStatusName + ')'
                    : null}
                </div>
              </React.Fragment>
            )}
          />
          <Column
            title="เจ้าของบ้าน"
            dataIndex="customer_name"
            key="customer_name"
          />
          <Column
            title="Action"
            key="action"
            width="60px"
            render={(text, record) => (
              <>
                <Button
                  style={{ textAlign: 'left' }}
                  icon={<SearchOutlined />}
                  size="small"
                  onClick={() => this.showModalView(record)}
                  block
                >
                  ดู
                </Button>
                {record.job_status.toString() != '-1' &&
                record.job_status.toString() != '-2' &&
                record.job_status.toString() != '3' ? (
                  <>
                    <Button
                      type="text"
                      style={{ textAlign: 'left' }}
                      icon={<EditOutlined />}
                      size="small"
                      onClick={() => this.showModalEdit(record)}
                      block
                    >
                      แก้ไข
                    </Button>
                    {/* ยกเลิกคิวงาน */}
                    <Tooltip title="ยกเลิกคิวงาน" placement="left">
                      <Popconfirm
                        placement="leftTop"
                        title={
                          'ต้องการยกเลิกคิวงาน ID#' +
                          record.id +
                          ' ใช่หรือไม่ ?'
                        }
                        icon={<QuestionCircleFilled />}
                        onConfirm={() => this.cancelJob(record)}
                      >
                        <Button
                          style={{
                            textAlign: 'left',
                            backgroundColor: '#f9651e',
                            color: '#ffffff',
                          }}
                          type="danger"
                          icon={<DeleteFilled />}
                          size="small"
                          block
                        >
                          ยกเลิก
                        </Button>
                      </Popconfirm>
                    </Tooltip>

                    {/* ลบคิวงานทิ้ง */}
                    <Tooltip title="ลบคิวงานทิ้ง" placement="left">
                      <Popconfirm
                        placement="leftTop"
                        title={
                          'ยืนยันลบรายการ ID#' + record.id + ' ใช่หรือไม่ ?'
                        }
                        icon={<QuestionCircleFilled />}
                        onConfirm={() => this.deleteJob(record, this.key)}
                      >
                        <Button
                          style={{ textAlign: 'left' }}
                          type="danger"
                          icon={<DeleteFilled />}
                          size="small"
                          block
                        >
                          ลบ
                        </Button>
                      </Popconfirm>
                    </Tooltip>
                    {/* แสดงปุ่มปิดงานถ้าใบแจ้งซ่อมอยู่ในสถานะ [กำลังดำเนินการ] และมีคิวงานมากกว่า 0 รายการ*/}
                    {canCloseJob(record) ? (
                      <Tooltip
                        title="ปิดงาน (เปลี่ยนสถานะเป็นเสร็จสิ้น)"
                        placement="left"
                      >
                        <Popconfirm
                          title={
                            'ยืนยันงานเสร็จสิ้น หมายเลข ' +
                            record.id +
                            ' ใช่หรือไม่ ？'
                          }
                          icon={
                            <QuestionCircleOutlined style={{ color: 'red' }} />
                          }
                          okText="งานเสร็จแล้ว"
                          cancelText="ยกเลิก"
                          placement="left"
                          onConfirm={() => this.closeJob(record)}
                        >
                          <Button
                            style={{
                              textAlign: 'left',
                              backgroundColor: '#2b8426',
                              color: '#ffffff',
                            }}
                            size="small"
                            type="light"
                            icon={<TrophyOutlined />}
                            block
                          >
                            ปิดงาน
                          </Button>
                        </Popconfirm>
                      </Tooltip>
                    ) : null}
                  </>
                ) : (
                  ''
                )}
              </>
            )}
          />
        </Table>
      </React.Fragment>
    )
  }
}
// export default InformfixList;
export default withRouter(JobProceed)
